import type { ComponentPropsWithoutRef } from 'react';
import { UserRoundCog } from 'lucide-react';
import type { DemoOption } from '@shared/schemas/admin-access';
import { emailToDisplayName } from '../../view-system/utils/displayFormatters';

type DemoOptionRowProps = {
  option: DemoOption;
  onSelect: (option: DemoOption) => void;
  selected?: boolean;
} & Omit<ComponentPropsWithoutRef<'button'>, 'onClick' | 'onSelect' | 'className' | 'children' | 'type' | 'aria-label'>;

/** One demo identity: display name, email label and a Demo badge. */
export function DemoOptionRow({ option, onSelect, selected = false, ...buttonProps }: DemoOptionRowProps) {
  return (
    <button
      {...buttonProps}
      type="button"
      aria-label={`Start demo as ${option.label}`}
      onClick={() => onSelect(option)}
      className={`flex w-full items-center gap-3 px-4 py-2.5 text-left disabled:opacity-50 ${
        selected ? 'bg-bg-selected' : 'hover:bg-bg-secondary'
      }`}
    >
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-bg-orange text-content-warning">
        <UserRoundCog className="h-4 w-4" aria-hidden="true" />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block truncate text-sm font-medium text-content-primary">{emailToDisplayName(option.label)}</span>
        <span className="block truncate text-xs text-content-tertiary">{option.label}</span>
      </span>
      <span className="rounded-full border border-secondary bg-bg-secondary px-2 py-0.5 text-[10px] font-semibold text-content-secondary">
        Demo
      </span>
    </button>
  );
}
